/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".rootIsFixed_d398da72{position:fixed;z-index:1000000;top:0;left:0;width:100vw;height:100vh;visibility:hidden}.content_d398da72{visibility:visible}\n"}]);
export const rootIsFixed = "rootIsFixed_d398da72";
export const content = "content_d398da72";